import '../../resources/css/separator.css';

export default function Separator({ className }) {

    return (
        <div className={'separator ' + className}>
            <span className="separator-top-line">
                <span className="separator-child-line"></span>
            </span>
        </div>
    );
}